import useCheckExamStatusByExamCardId from './useCheckExamStatusByExamCardId';

export default useCheckExamStatusByExamCardId;
